import { KEYSTONE_URL } from 'config';

export const getUserEditPageUrl = (userId: string): string => `${KEYSTONE_URL}/users/${userId}`;
